import React, { useEffect } from 'react';
import { InvitedSpeakers } from '../components';
// import { InvitedSpeakers } from "../components";

const InvitedSpeakerPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <InvitedSpeakers />
      {/* <CommingSoonBanner /> */}
    </div>
  );
};

export default InvitedSpeakerPage;
